/*
 * Error Routing Module
 * <p>
 *
 * @author atanas.kovachev
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes
} from '@angular/router';
import { ReporterResolverErrorComponent } from './reporter-resolver-error/reporter-resolver-error.component';
import { NotFoundComponent } from 'app/features/error/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    component: ReporterResolverErrorComponent,
  }, {
    path: '404',
    component: NotFoundComponent,
  },
];

@NgModule ( {
  imports: [ RouterModule.forChild ( routes ) ],
  exports: [ RouterModule ]
} )
export class ErrorRoutingModule {}
